import React from 'react';
import {withRouter} from "react-router";

import API from "@beardeddevops/react.api";
import APPCONFIG from 'constants/Config';
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Card from "@material-ui/core/Card";

import {Button} from "reactstrap";


/**
 *  @property {Accounts_Object} state
 *  @property {object} model
 *  @property {Accounts_Properties} model.properties
 *  @property {Accounts_Is} model.is
 *  @property {Accounts_Has} model.has
 */
class Register extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Accounts._name);
		this.model.requestType = API.RequestType.CREATE;
		this.state.step = 1;
		this.brand = APPCONFIG.brand;

		this.handleNext = this.handleNext.bind(this);
		this.handlePrevious = this.handlePrevious.bind(this);
	}

	handleNext() {
		let shouldContinue = API.Validator.process(this, this.requestType, true, null, this.state.step);
		console.log(shouldContinue);
		if (shouldContinue) {
			this.setState({"step": this.state.step + 1});
		}
	};

	handlePrevious = () => {
		this.setState({"step": this.state.step - 1});
	};

	handleSubmit = async event => {
		if (typeof event !== 'undefined') event.preventDefault();
		this.setState({loading: true});
		if (this.handleProcess()) {
			await this.model.submit(this, API.RequestType.READ);
			this.props.history.push('/');
		} else {
			this.setState({loading: false});
		}
		return false;
	};

	render() {

		let {properties} = this.model;
		let {
			loading,
			name_first,
			name_first_error,
			name_last,
			name_last_error,
			email,
			email_error,
			password,
			password_error,
			step,
		} = this.state;
		let brand = this.brand;

		return (
			<div className="body-inner">

				{/*#region Step 1*/}

				{step === 1 ?
					<Card>
						<CardContent style={{paddingBottom: 0}}>
							<section className="logo text-center">
								<h1>{brand}</h1>
							</section>
							<fieldset>
								<div className="row">
									<div className="col-md">
										<div className="form-group">
											<Framework.Elements.TextField
												label="First Name"
												value={name_first}
												error={name_first_error}
												property={properties.name_first}
												update={this.handleTextFieldPropertyUpdate}
												variant="standard"
											/>
										</div>
									</div>
									<div className="col-md">
										<div className="form-group">
											<Framework.Elements.TextField
												label="Last Name"
												value={name_last}
												error={name_last_error}
												property={properties.name_last}
												update={this.handleTextFieldPropertyUpdate}
												variant="standard"
											/>
										</div>
									</div>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										value={email}
										error={email_error}
										property={properties.email}
										update={this.handleTextFieldPropertyUpdate}
										variant="standard"
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										value={password}
										error={password_error}
										property={properties.password}
										update={this.handleTextFieldPropertyUpdate}
										variant="standard"
										type="password"
									/>
								</div>
							</fieldset>
						</CardContent>
						<CardActions>
							<Button
								onClick={() => this.props.history.push('/login')}
								data-id="back-to-login-button"
								color="secondary"
								size="md"
								block={false}
							>
								Back to Login
							</Button>
							<Button
								onClick={this.handleNext}
								data-id="next-button"
								color="primary"
								size="md"
								block={false}
							>
								Next
							</Button>
						</CardActions>
					</Card> : null}

				{/*#endregion*/}

				{/*#region Step 2*/}

				{step === 2 ?
					<Card>
						<CardContent>
							<section className="logo text-center">
								<h1>{brand}</h1>
							</section>
							{/*<fieldset>*/}
							{/*	<div className="form-group">*/}
							{/*		<Framework.Elements.TextField*/}
							{/*			label={'Company Name'}*/}
							{/*			value={name_company}*/}
							{/*			error={name_company_error}*/}
							{/*			property={properties.name_company}*/}
							{/*			update={this.handleTextFieldPropertyUpdate}*/}
							{/*			variant="standard"}*/}
							{/*		/>*/}
							{/*	</div>*/}
							{/*	<div className="row">*/}
							{/*		<div className="col-md-7">*/}
							{/*			<div className="form-group">*/}
							{/*				<Framework.Elements.TextField*/}
							{/*					value={street_1}*/}
							{/*					error={street_1_error}*/}
							{/*					property={properties.street_1}*/}
							{/*					update={this.handleTextFieldPropertyUpdate}*/}
							{/*					variant="standard"}*/}
							{/*				/>*/}
							{/*			</div>*/}
							{/*		</div>*/}
							{/*		/!*Removed Per Matt*!/*/}
							{/*		/!*<div className="col-md-5">*!/*/}
							{/*		/!*	<div className="form-group">*!/*/}
							{/*		/!*		<Framework.Elements.TextField*!/*/}
							{/*		/!*			value={street_2}*!/*/}
							{/*		/!*			error={street_2_error}*!/*/}
							{/*		/!*			property={properties.street_2}*!/*/}
							{/*		/!*			update={this.handleTextFieldPropertyUpdate}*!/*/}
							{/*		/!*			variant="standard"}*!/*/}
							{/*		/!*		/>*!/*/}
							{/*		/!*	</div>*!/*/}
							{/*		/!*</div>*!/*/}
							{/*	</div>*/}
							{/*	<div className="row">*/}
							{/*		<div className="col-md-4">*/}
							{/*			<div className="form-group">*/}
							{/*				<Framework.Elements.TextField*/}
							{/*					value={city}*/}
							{/*					error={city_error}*/}
							{/*					property={properties.city}*/}
							{/*					update={this.handleTextFieldPropertyUpdate}*/}
							{/*					variant="standard"}*/}
							{/*				/>*/}
							{/*			</div>*/}
							{/*		</div>*/}
							{/*		<div className="col-md-5">*/}
							{/*			<div className="form-group" style={{paddingTop: '10px'}}>*/}
							{/*				<Framework.Elements.Select*/}
							{/*					shouldLoad={this.state.loaded}*/}
							{/*					update={this.handleSelectPropertyUpdate}*/}
							{/*					property={properties.state}*/}
							{/*					value={state}*/}
							{/*					error={state_error}*/}
							{/*					autoload={true}*/}
							{/*					id={'short'}*/}
							{/*					model={Types.States._name}*/}
							{/*					nullable={false}*/}
							{/*					limit={null}*/}
							{/*				/>*/}
							{/*			</div>*/}
							{/*		</div>*/}
							{/*		<div className="col-md-3">*/}
							{/*			<div className="form-group">*/}
							{/*				<Framework.Elements.TextField*/}
							{/*					value={zip}*/}
							{/*					error={zip_error}*/}
							{/*					property={properties.zip}*/}
							{/*					update={this.handleTextFieldPropertyUpdate}*/}
							{/*					variant="standard"}*/}
							{/*				/>*/}
							{/*			</div>*/}
							{/*		</div>*/}
							{/*	</div>*/}

							{/*	<hr/>*/}

							{/*</fieldset>*/}
						</CardContent>
						<CardActions>
							<Button onClick={this.handlePrevious} data-id="back-button" color="secondary" size="md" block={false}>Back</Button>
							<Button onClick={this.handleSubmit} data-id="sign-up-button" color="primary" size="md" block={false}>Sign Up</Button>
						</CardActions>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</Card> : null}

				{/*#endregion*/}

			</div>
		);
	}
}

const RegisterRoute = withRouter(Register);
const Page = () => (
	<div className="page-signup">
		<div className="main-body">
			<div key="1">
				<RegisterRoute/>
			</div>
		</div>
	</div>
);

export default Page;
